module.exports = __webpack_public_path__ + "static/img/honor24.8c0095e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor24.png
// module id = RzhC
// module chunks = 0